const ErrorMessage = ({ message }: { message: string }) => {
  return (
    <span
      style={{
        color: '#ff6b00',
        fontSize: '0.75rem',
        lineHeight: '1.25rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '0px',
      }}
    >
      <img src="/src/assets/images/svg/ic_error_ifo.svg" alt="error" />
      {message}
    </span>
  );
};

export default ErrorMessage;
